import { type ComponentProps } from 'react';
import { Badge } from '../../components/ui/badge';
import { cn } from '../../lib/utils';

export type StatusLevel = 'success' | 'warning' | 'danger' | 'neutral';

const levelClassNames: Record<StatusLevel, string> = {
  success:
    'bg-green-600/10 text-green-700 dark:bg-green-500/20 dark:text-green-400',
  warning:
    'bg-amber-500/15 text-amber-700 dark:bg-amber-500/20 dark:text-amber-400',
  danger: 'bg-destructive/10 text-destructive dark:bg-destructive/20',
  neutral: '',
};

export type StatusBadgeProps = Omit<ComponentProps<typeof Badge>, 'variant'> & {
  level: StatusLevel;
};

/** A badge coloured by how good a status / value is (green, amber, red, or the neutral secondary badge) */
export const StatusBadge = ({
  level,
  className,
  ...props
}: StatusBadgeProps) => (
  <Badge
    variant="secondary"
    data-level={level}
    className={cn(levelClassNames[level], className)}
    {...props}
  />
);
